import '../../styles/web-components/color-swatch-list.scss';
import { getAlternateTemplate } from '../services/template.service';
import { refreshWishlistIcons } from '../services/wishlist.service';
const MAX_MOBILE_COLOR_SWATCHES = 5;
const MAX_TABLET_COLOR_SWATCHES = 10;
const MAX_DESKTOP_COLOR_SWATCHES = 6;
class ColorSwatchList extends HTMLElement {
    _onSwatchClick;
    observer;
    productHandle;
    constructor() {
        super();
        this._onSwatchClick = this.onSwatchClick.bind(this);
        this.addEventListener('click', this._onSwatchClick);
    }
    connectedCallback() {
        this.productHandle = this.dataset.productHandle;
        if (!this.children.length) {
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.addedNodes.length) {
                        this.updateColorSwatchCount();
                    }
                });
            });
            this.observer.observe(this, { childList: true });
        }
        else {
            this.updateColorSwatchCount();
        }
    }
    disconnectedCallback() {
        console.log('ColorSwatchList disconnectedCallback', this.productHandle);
        this.removeEventListener('click', this._onSwatchClick);
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    async onSwatchClick(e) {
        const target = e.target;
        if (target.classList.contains("js-product-option") && !target.classList.contains("product-option--selected")) {
            e.stopPropagation();
            const initialColorSwatches = target.closest(".product-grid-item-v2__product-swatch-container");
            if (initialColorSwatches) {
                initialColorSwatches.querySelectorAll(".js-product-option").forEach(c => c.classList.remove("product-option--selected"));
                target.classList.add("product-option--selected");
                const handle = target.dataset.productHandle;
                const productCardHTML = await getAlternateTemplate(`/collections/${window.collectionHandle}/products/${handle}`, 'plp-card');
                const productCardEl = target.closest(".boost-pfs-filter-product-item");
                productCardEl.innerHTML = productCardHTML;
                // ensures that the new color swatches are rendered in the same position as the initial color swatches
                const newColorSwatches = productCardEl.querySelector('.product-grid-item-v2__product-swatch-container');
                newColorSwatches.replaceWith(initialColorSwatches);
                if (typeof window.boostSwapImage === 'function') {
                    window.boostSwapImage();
                }
                refreshWishlistIcons('.boost-pfs-filter-products');
            }
        }
    }
    renderAdditionalColorSwatches(numRemaining, context) {
        const link = document.createElement('a');
        link.classList.add(`color-swatch-list__additional-color-swatches`, `color-swatch-list__additional-color-swatches--${context}`);
        link.href = window.collectionHandle ? `/collections/${window.collectionHandle}/products/${this.productHandle}` : `/products/${this.productHandle}`;
        link.textContent = `+ ${numRemaining}`;
        return link;
    }
    updateColorSwatchCount() {
        const colorSwatchListItems = this.querySelectorAll(".product-option__value-listitem");
        const colorSwatchCount = colorSwatchListItems.length;
        const colorSwatchList = this.firstElementChild;
        const hasMoreThanMaxMobileColorSwatches = colorSwatchCount > MAX_MOBILE_COLOR_SWATCHES;
        const hasMoreThanMaxTabletColorSwatches = colorSwatchCount > MAX_TABLET_COLOR_SWATCHES;
        const hasMoreThanMaxDesktopColorSwatches = colorSwatchCount > MAX_DESKTOP_COLOR_SWATCHES;
        if (hasMoreThanMaxMobileColorSwatches) {
            colorSwatchList?.appendChild(this.renderAdditionalColorSwatches(colorSwatchCount - (MAX_MOBILE_COLOR_SWATCHES - 1), 'mobile'));
        }
        if (hasMoreThanMaxTabletColorSwatches) {
            colorSwatchList?.appendChild(this.renderAdditionalColorSwatches(colorSwatchCount - (MAX_TABLET_COLOR_SWATCHES - 1), 'tablet'));
        }
        if (hasMoreThanMaxDesktopColorSwatches) {
            colorSwatchList?.appendChild(this.renderAdditionalColorSwatches(colorSwatchCount - (MAX_DESKTOP_COLOR_SWATCHES - 1), 'desktop'));
        }
        colorSwatchListItems.forEach((li, index) => {
            const oneIndex = index + 1;
            if (hasMoreThanMaxMobileColorSwatches && oneIndex >= MAX_MOBILE_COLOR_SWATCHES) {
                li.classList.add('color-swatch-list__listitem--hidden-mobile');
            }
            if (hasMoreThanMaxTabletColorSwatches && oneIndex >= MAX_TABLET_COLOR_SWATCHES) {
                li.classList.add('color-swatch-list__listitem--hidden-tablet');
            }
            if (hasMoreThanMaxDesktopColorSwatches && oneIndex >= MAX_DESKTOP_COLOR_SWATCHES) {
                li.classList.add('color-swatch-list__listitem--hidden-desktop');
            }
        });
    }
}
if (!window.customElements.get("color-swatch-list")) {
    customElements.define("color-swatch-list", ColorSwatchList);
}
